import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import SelectAsync from 'react-select/async';

export default class CompanySetting extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true
        }
    }
    componentDidMount() {
        this.httpPost("api/v1/company/getcurrent", {})
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === -2) {
                this.setState({
                    data: data,
                    loading: false
                })
            }
            if (data.status === 1) {
                window.companyId = data.global.company.id;
                this.setState({
                    data: data,
                    loading: false
                })
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }

    loadAccountOptions(inputValue, callback, type, parentCode) {
        var companyId = window.companyId;
        setTimeout(() => {
            fetch("/api/v1/common/getaccounts/", {
                method: "post",
                body: JSON.stringify({
                    "term": inputValue,
                    "type": 3,
                    "parentCode": 0,
                    companyId,
                }),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(response => {
                    let items = [];
                    if (response.status == 1) {
                        response.records.map(_record => items.push({
                            value: _record.fullCode,
                            label: _record.title,
                            moeinDetailed: _record.detailed
                        }));
                    }
                    callback(items);
                })
        }, 50);
    }
    save(e) {
        e.preventDefault();

        if (this.isBlank(this.state.data.record.autoDocumentSaleMoin)) this.state.data.record.autoDocumentSaleMoin = 0;
        if (this.isBlank(this.state.data.record.autoDocumentBuyMoin)) this.state.data.record.autoDocumentBuyMoin = 0;
        if (this.isBlank(this.state.data.record.autoDocumentSaleDiscountMoin)) this.state.data.record.autoDocumentSaleDiscountMoin = 0;
        if (this.isBlank(this.state.data.record.autoDocumentBuyDiscountMoin)) this.state.data.record.autoDocumentBuyDiscountMoin = 0;
        if (this.isBlank(this.state.data.record.autoDocumentSaleVatMoin)) this.state.data.record.autoDocumentSaleVatMoin = 0;
        if (this.isBlank(this.state.data.record.autoDocumentBuyVatMoin)) this.state.data.record.autoDocumentBuyVatMoin = 0;
        if (this.isBlank(this.state.data.record.autoDocumentBahayeTamamShode)) this.state.data.record.autoDocumentBahayeTamamShode = 0;
        if (this.isBlank(this.state.data.record.autoDocumentMojodiKala)) this.state.data.record.autoDocumentMojodiKala = 0;

        this.httpPost("api/v1/company/savesetting", {
            privateKey: this.state.data.record.privateKey,
            taxUserName: this.state.data.record.taxUserName,
            isSandbox: this.state.data.record.isSandbox,

            autoDocumentSaleMoin: this.state.data.record.autoDocumentSaleMoin,
            autoDocumentBuyMoin: this.state.data.record.autoDocumentBuyMoin,
            autoDocumentSaleDiscountMoin: this.state.data.record.autoDocumentSaleDiscountMoin,
            autoDocumentBuyDiscountMoin: this.state.data.record.autoDocumentBuyDiscountMoin,
            autoDocumentSaleVatMoin: this.state.data.record.autoDocumentSaleVatMoin,
            autoDocumentBuyVatMoin: this.state.data.record.autoDocumentBuyVatMoin,
            autoDocumentBahayeTamamShode: this.state.data.record.autoDocumentBahayeTamamShode,
            autoDocumentMojodiKala: this.state.data.record.autoDocumentMojodiKala,

            allowNegativeInventory: this.state.data.record.allowNegativeInventory,
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    renderForm() {


        return <form method="post" onSubmit={e => this.save(e)} className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            <div className="nk-content-body">
                                <div className="components-preview wide-md mx-auto">
									<div className="nk-block nk-block-lg">
                                <div className="card card-bordered">

                                            <div className="card-inner">
                                                <ul className="nav nav-tabs mt-n3">
                                                    <li className="nav-item">
                                                        <a className="nav-link active" data-bs-toggle="tab" href="#tax"><em className="icon ni ni-list-round"></em><span>سامانه مودیان</span></a>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a className="nav-link" data-bs-toggle="tab" href="#autodoc"><em className="icon ni ni-list-round"></em><span>مشتریان و فروش</span></a>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a className="nav-link" data-bs-toggle="tab" href="#warehouse"><em className="icon ni ni-list-round"></em><span>انبارداری</span></a>
                                                    </li>
                                                </ul>
                                                <div className="tab-content">
                                                    <div className="tab-pane active" id="tax">
                                                        <div className="row g-4">
                                                            <div className="col-lg-3">
                                                                <div className="form-group">
                                                                    <label className="form-label">شناسه حافظه مالیاتی</label>
                                                                    <div className="form-control-wrap">
                                                                        <input className="form-control ltr" maxLength="6" type="text" defaultValue={this.state.data.record.taxUserName} onChange={e => this.state.data.record.taxUserName = e.target.value} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-9">
                                                                <div className="form-group">
                                                                    <label className="form-label">نوع شناسه</label>
                                                                    <div className="form-control-wrap">
                                                                        <select className="form-control" defaultValue={this.state.data.record.isSandbox} onChange={e => this.state.data.record.isSandbox = (e.target.value == 'true' ? true : false)}>
                                                                            <option value="true">شناسه حافظه مربوط به سامانه آزمایشی (سند باکس) است</option>
                                                                            <option value="false">شناسه حافظه از سامانه اصلی مودیان دریافت شده است</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-12">
                                                                <div className="form-group">
                                                                    <label className="form-label">متن فایل کلید خصوصی</label>
                                                                    <div className="form-control-wrap">
                                                                        <textarea className="form-control ltr" type="text" defaultValue={this.state.data.record.privateKey} onChange={e => this.state.data.record.privateKey = e.target.value} ></textarea>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="tab-pane" id="autodoc">
                                                        <div className="row g-4">
                                                            <div className="col-lg-3">
                                                                <div className="form-group">
                                                                    <label className="form-label">معین فروش</label>
                                                                    <div className="form-control-wrap">
                                                                        <SelectAsync
                                                                            style={{ "width": "100%" }}
                                                                    defaultValue={!this.isNull(this.state.data.autoDocumentSaleMoin) ? [{ value: this.state.data.autoDocumentSaleMoin.fullCode, label: this.state.data.autoDocumentSaleMoin.title }] : null}
                                                                            isMulti={false}
                                                                            placeholder="انتخاب معین فروش"
                                                                            defaultOptions
                                                                            loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 3, 0)}
                                                                            onChange={e => this.state.data.record.autoDocumentSaleMoin = e.value}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-3">
                                                                <div className="form-group">
                                                                    <label className="form-label">معین تخفیفات فروش</label>
                                                                    <div className="form-control-wrap">
                                                                        <SelectAsync
                                                                            style={{ "width": "100%" }}
                                                                    defaultValue={!this.isNull(this.state.data.autoDocumentSaleDiscountMoin) ? [{ value: this.state.data.autoDocumentSaleDiscountMoin.fullCode, label: this.state.data.autoDocumentSaleDiscountMoin.title }] : null}
                                                                            isMulti={false}
                                                                            placeholder="انتخاب معین تخفیفات فروش"
                                                                            defaultOptions
                                                                            loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 3, 0)}
                                                                            onChange={e => this.state.data.record.autoDocumentSaleDiscountMoin = e.value}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-3">
                                                                <div className="form-group">
                                                                    <label className="form-label">معین ارزش افزوده فروش</label>
                                                                    <div className="form-control-wrap">
                                                                        <SelectAsync
                                                                            style={{ "width": "100%" }}
                                                                    defaultValue={!this.isNull(this.state.data.autoDocumentSaleVatMoin) ? [{ value: this.state.data.autoDocumentSaleVatMoin.fullCode, label: this.state.data.autoDocumentSaleVatMoin.title }] : null}
                                                                            isMulti={false}
                                                                            placeholder="انتخاب معین ارزش افزوده فروش"
                                                                            defaultOptions
                                                                            loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 3, 0)}
                                                                            onChange={e => this.state.data.record.autoDocumentSaleVatMoin = e.value}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row g-4 mt-2">
                                                            <div className="col-lg-3">
                                                                <div className="form-group">
                                                                    <label className="form-label">معین خرید</label>
                                                                    <div className="form-control-wrap">
                                                                        <SelectAsync
                                                                            style={{ "width": "100%" }}
                                                                    defaultValue={!this.isNull(this.state.data.autoDocumentBuyMoin) ? [{ value: this.state.data.autoDocumentBuyMoin.fullCode, label: this.state.data.autoDocumentBuyMoin.title }] : null}
                                                                            isMulti={false}
                                                                    placeholder="انتخاب معین خرید"
                                                                            defaultOptions
                                                                            loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 3, 0)}
                                                                            onChange={e => this.state.data.record.autoDocumentBuyMoin = e.value}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-3">
                                                                <div className="form-group">
                                                                    <label className="form-label">معین تخفیفات خرید</label>
                                                                    <div className="form-control-wrap">
                                                                        <SelectAsync
                                                                            style={{ "width": "100%" }}
                                                                    defaultValue={!this.isNull(this.state.data.autoDocumentBuyDiscountMoin) ? [{ value: this.state.data.autoDocumentBuyDiscountMoin.fullCode, label: this.state.data.autoDocumentBuyDiscountMoin.title }] : null}
                                                                            isMulti={false}
                                                                            placeholder="انتخاب معین تخفیفات خرید"
                                                                            defaultOptions
                                                                            loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 3, 0)}
                                                                            onChange={e => this.state.data.record.autoDocumentBuyDiscountMoin = e.value}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-3">
                                                                <div className="form-group">
                                                                    <label className="form-label">معین ارزش افزوده خرید</label>
                                                                    <div className="form-control-wrap">
                                                                        <SelectAsync
                                                                            style={{ "width": "100%" }}
                                                                    defaultValue={!this.isNull(this.state.data.autoDocumentBuyVatMoin) ? [{ value: this.state.data.autoDocumentBuyVatMoin.fullCode, label: this.state.data.autoDocumentBuyVatMoin.title }] : null}
                                                                            isMulti={false}
                                                                            placeholder="انتخاب معین ارزش افزوده خرید"
                                                                            defaultOptions
                                                                            loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 3, 0)}
                                                                            onChange={e => this.state.data.record.autoDocumentBuyVatMoin = e.value}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="tab-pane" id="warehouse">
                                                        <div className="row g-4">
                                                            <div className="col-lg-3">
                                                                <div className="form-group">
                                                                    <label className="form-label">معین بهای تمام شده</label>
                                                                    <div className="form-control-wrap">
                                                                        <SelectAsync
                                                                            style={{ "width": "100%" }}
                                                                            defaultValue={!this.isNull(this.state.data.autoDocumentBahayeTamamShode) ? [{ value: this.state.data.autoDocumentBahayeTamamShode.fullCode, label: this.state.data.autoDocumentBahayeTamamShode.title }] : null}
                                                                            isMulti={false}
                                                                            placeholder="انتخاب معین بهای تمام شده"
                                                                            defaultOptions
                                                                            loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 3, 0)}
                                                                            onChange={e => this.state.data.record.autoDocumentBahayeTamamShode = e.value}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-lg-3">
                                                                <div className="form-group">
                                                                    <label className="form-label">معین موجودی کالا</label>
                                                                    <div className="form-control-wrap">
                                                                        <SelectAsync
                                                                            style={{ "width": "100%" }}
                                                                            defaultValue={!this.isNull(this.state.data.autoDocumentMojodiKala) ? [{ value: this.state.data.autoDocumentMojodiKala.fullCode, label: this.state.data.autoDocumentMojodiKala.title }] : null}
                                                                            isMulti={false}
                                                                            placeholder="انتخاب معین موجودی کالا"
                                                                            defaultOptions
                                                                            loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 3, 0)}
                                                                            onChange={e => this.state.data.record.autoDocumentMojodiKala = e.value}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="row g-4 mt-2">
                                                            <div className="col-lg-3">
                                                                <div className="form-group">
                                                                    <label className="form-label">ثبت موجودی منفی</label>
                                                                    <div className="form-control-wrap">
                                                                <select className="form-control" defaultValue={this.state.data.record.allowNegativeInventory ? 1 : 0} onChange={e => this.state.data.record.allowNegativeInventory = (e.target.value == "1" ? true : false)}>
                                                                            <option value="0">مجاز نیست</option>
                                                                            <option value="1">مشکلی ندارد</option>
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-12" style={{ "marginTop":"10px"}}>
                                                        <div className="form-group">
                                                            <button type="submit" className="btn btn-lg btn-primary">ذخیره</button>
                                                        </div>
                                                    </div>
                                                 </div>
                                           </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
    }
    SetCheckedInInsu(f, v) {
        f = "[" + f + "]";
        this.state.data.record.inInsu = this.state.data.record.inInsu.replace(f, "");
        if (v) this.state.data.record.inInsu += f;
    }
    IsCheckedInsu(f) {
        f = "[" + f + "]";
        return this.state.data.record.inInsu.includes(f);
    }
    SetCheckedInTax(f, v) {
        f = "[" + f + "]";
        this.state.data.record.inTax = this.state.data.record.inTax.replace(f, "");
        if (v) this.state.data.record.inTax += f;
    }
    IsCheckedInTax(f) {
        f = "[" + f + "]";
        return this.state.data.record.inTax.includes(f);
    }
    SetCheckedInReward(f, v) {
        f = "[" + f + "]";
        this.state.data.record.inReward = this.state.data.record.inReward.replace(f, "");
        if (v) this.state.data.record.inReward += f;
    }
    IsCheckedInReward(f) {
        f = "[" + f + "]";
        return this.state.data.record.inReward.includes(f);
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() : 
                    [
                        this.state.lockScreen === 1 && this.lockScreen(),
                        <Header data={this.state.data} />,
                        <div className="nk-content ">
                            <div className="container-fluid">
                                <div className="nk-content-inner">
                                    {this.isEmptyCompanies(this.state.data.global) ? this.renderNoCompanyRegister() : this.renderForm()}
                                </div>
                            </div>
                        </div>,
                <Footer />
            ];
        return contents;
    }
}